import React, { useCallback, useState } from 'react';
import { networkUploadMediaFile } from 'src/network/FileManager';
import { Button, InputAdornment, Tooltip } from '@mui/material';
import { Controller } from 'react-hook-form';
import Iconify from '../Iconify';
import { useSnackbar } from 'notistack';
import { useDropzone } from 'react-dropzone';
import { RHFTextField } from '../hook-form';

const GeneralMediaUploader = ({ name, label, id, afterChangeAction, ...rest }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [mediaFile, setMediaFile] = useState();

  const acceptValue = 'audio/*,video/mp4';

  // -------------------------------------------------------------------

  const uploadFileHandler = (form_data) => {
    setLoading(true);
    networkUploadMediaFile(form_data)
      .then((res) => {
        if (res.data.Status === 'OK') {
          afterChangeAction(res.data.UrlFile);
          setMediaFile(res.data.UrlFile);
        }
      })
      .catch(() => {
        enqueueSnackbar('مشکلی پیش آمده، لطفا مجددا امتحان کنید', { variant: 'error' });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleChangeFile = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file) {
      let form_data = new FormData();
      form_data.append('file', file);

      uploadFileHandler(form_data);
    }
  };

  const onDrop = useCallback((acceptedFiles) => {
    handleChangeFile(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    accept: acceptValue,
    noClick: true,
    noKeyboard: true,
  });

  return (
    <>
      <Controller
        name={name}
        render={({ field }) => (
          <RHFTextField
            dir="ltr"
            fullWidth
            variant="outlined"
            label={label}
            value={field.value || ''}
            autoComplete="off"
            {...getRootProps()}
            {...rest}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <input
                    id={id}
                    type="file"
                    style={{ display: 'none' }}
                    onChange={(e) => handleChangeFile(e.target.files)}
                    {...getInputProps()}
                  />

                  {field.value || mediaFile ? (
                    <Button
                      size="small"
                      color="inherit"
                      variant="contained"
                      sx={{ ml: 1 }}
                      onClick={(event) => {
                        event.stopPropagation();
                        window.open(field.value || mediaFile, '_blank');
                      }}
                    >
                      پخش
                    </Button>
                  ) : null}

                  <span className="cursor-pointer absolute left-2" onClick={open}>
                    {loading ? (
                      <Iconify width={30} height={30} icon={'svg-spinners:270-ring'} />
                    ) : (
                      <Tooltip title={label}>
                        <span>
                          <Iconify width={30} height={30} icon={'ep:upload-filled'} />
                        </span>
                      </Tooltip>
                    )}
                  </span>
                </InputAdornment>
              ),
              sx: { paddingRight: '45px' },
            }}
            {...field}
          />
        )}
      />
    </>
  );
};

export default GeneralMediaUploader;
